import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface IConfirmModalComponentData {
  title: string;
  message: string;
  subMessage?: string;
  confirmText?: string;
}

@Component({
  template: require('./confirm-modal.component.html'),
  styles: [require('./confirm-modal.component.scss')],
})
export class ConfirmModalComponent implements OnInit {
  title: string;
  message: string;
  subMessage: string;
  confirmText: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IConfirmModalComponentData,
  ) {}

  ngOnInit(): void {
    this.title = this.data.title;
    this.message = this.data.message;
    this.subMessage = this.data.subMessage;
    this.confirmText = this.data.confirmText || 'OK';
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
